module.exports = __webpack_public_path__ + "static/allen-07f81f5e305c51f214a2d66c98d37152.png";